// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ttkCY","root__heading":"style-module__root__heading___OE1i3","root__text":"style-module__root__text___fGM1D","root__list":"style-module__root__list___BmAhS","root__list_item":"style-module__root__list_item___lazgC"};
    if(module.hot) {
      // 1697460476164
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  